import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { createInterviewLocations } from '../../Repositories/interviewLocations/interviewLocations';

const interviewLocationRequest = createInterviewLocations();

/**
 * this function(query) is to get all interview locations
 * @function useInterviewLocationGetQuery
 * @param {Object} reqParams - params passed along with the API call
 * @param {Object} options - query options (e.g. enabled, refetching rules)
 * @returns API response
 */
export function useInterviewLocationGetQuery(reqParams, options) {
  return useQuery(
    ['interviewLocationGetQuery', reqParams],
    () => interviewLocationRequest.getAllInterviewLocations(reqParams),
    {
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      ...options,
      enabled: reqParams?.edit,
    }
  );
}

/**
 * this function(mutation) is to add an interview location
 * @function useAddInterviewLocationMutation
 * @returns API response
 */
export function useAddInterviewLocationMutation() {
  const queryClient = useQueryClient();
  return useMutation(
    ['interviewLocationPostMutation'],
    (args) => interviewLocationRequest.postInterviewLocation(args),
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries(['interviewLocationGetQuery']);
      },
    }
  );
}

/**
 * this function(mutation) is to update an interview location by ID
 * @function useUpdateInterviewLocationMutationById
 * @returns API response
 */
export function useUpdateInterviewLocationMutationById() {
  const queryClient = useQueryClient();
  return useMutation(
    ['interviewLocationPutMutationById'],
    (args) => interviewLocationRequest.putInterviewLocationById(args),
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries(['interviewLocationGetQuery']);
      },
    }
  );
}

/**
 * this function(mutation) is to delete an interview location by ID
 * @function useDeleteInterviewLocationMutationById
 * @returns API response
 */
export function useDeleteInterviewLocationMutationById() {
  const queryClient = useQueryClient();
  return useMutation(
    ['interviewLocationDeleteMutationById'],
    (args) => interviewLocationRequest.deleteInterviewLocationById(args),
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries(['interviewLocationGetQuery']);
      },
    }
  );
}
